export default __webpack_public_path__ + "static/media/tn-ventas-02.e9e38f4a.jpg";